var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookings",
    transform: "translate(-273.000000, -253.000000)",
    fillRule: "nonzero",
    fill: "#C7C7CC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-bar",
    transform: "translate(251.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,22.8026197 L17.3459831,16.1614164 C20.6099309,12.284122 20.4452954,6.50861023 16.8084384,2.87777224 C12.9649606,-0.959257413 6.72616887,-0.959257413 2.88260838,2.87777224 C-0.96086946,6.71480189 -0.96086946,12.9431268 2.88260838,16.7802389 C4.78418111,18.6786214 7.34603133,19.6680774 9.86556561,19.6680774 C12.1383946,19.6680774 14.369073,18.8848956 16.2286604,17.3571465 L22.8826773,24 L24,22.8026197 Z M4.04001557,15.6251036 C0.858385534,12.4488113 0.858385534,7.2499596 4.04001557,4.07374989 C5.65099677,2.46547142 7.71720497,1.68063945 9.82539852,1.68063945 C11.9335921,1.68063945 14.04005,2.46382123 15.6107815,4.07374989 C18.7924115,7.25004211 18.7924115,12.4488939 15.6107815,15.6251036 C12.4291514,18.8013133 7.22156295,18.8013958 4.04001557,15.6251036 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.690f56f35f42ef4dc39409b5ab35e755.svg";
export { ForwardRef as ReactComponent };